export const KEY_USER_CHANGE_LANG = 'userChangeLang';
export const KEY_ACADEMIC_ROLES = {
  ClassTeacher: 'Class Teacher',
};
